@if (!previewMode && config?.widget?.text; as config) {
  <div
    class="w-full h-full"
    [class]="getTextColorBasedOnBackground(config.backgroundColor)">
    <p-editor
      appDebounceInput
      (ngModelChange)="onContentChange($event)"
      (onInit)="initEditor($event, config)"
      [modules]="quillModules"
      [(ngModel)]="htmlContent"
      [style]="{ height: '300px' }">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button type="button" class="ql-link" aria-label="Link"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-header">
            <option value="1">Überschrift</option>
            <option value="2">Untertitel</option>
            <option selected>Normal</option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-clean" pTooltip="Formatierungen entfernen"></button>
        </span>
        <!--
        <span>
          <button class="ql-fontawesome" (click)="addIcon()">
            <i class="fas fa-plus-circle"></i>
          </button>
        </span>-->

        <span class="ql-formats">
          <button class="ql-preview" (click)="togglePreview()">
            <i class="fas fa-eye"></i>
          </button>
        </span>
      </ng-template>
    </p-editor>
  </div>
} @else {
  <div
    class="preview-container"
    [class]="
      getTextColorBasedOnBackground(config?.widget?.text?.backgroundColor)
    ">
    @if (!gridStore.readonly()) {
      <button
        pButton
        class="close-preview p-button-xs"
        [rounded]="true"
        [raised]="true"
        icon="fas fa-pen"
        (click)="togglePreview()"></button>
    }
    <div class="p-3" [innerHTML]="config?.widget?.text?.content || ''"></div>
  </div>
}
<!--<div
    class="w-full h-full"
    [class]="getTextColorBasedOnBackground(config.widget.text.backgroundColor)">
    <p-editor [(ngModel)]="config.widget.text.content" (onInit)="initEditor($event)" [style]="{ height: '300px' }">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <select class="ql-header">
            <option value="1">Überschrift</option>
            <option value="2">Untertitel</option>
            <option selected>Normal</option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-preview" (click)="togglePreview()">
            <i class="fas fa-eye"></i>
          </button>
        </span>
      </ng-template>
    </p-editor>
  </div>-->

<!--<div class="editor-container">
  <div class="custom-toolbar">
    <button class="ql-bold" title="Bold"></button>
    <button class="ql-italic" title="Italic"></button>
  </div>
} @else {
  <div
    class="preview-container"
    [class]="
      getTextColorBasedOnBackground(config?.widget?.text?.backgroundColor)
    ">
    <button
      pButton
      class="close-preview p-button-xs"
      [rounded]="true"
      [outlined]="true"
      icon="fas fa-xmark"
      (click)="togglePreview()"></button>
    <div class="p-3" [innerHTML]="config?.widget?.text?.content || ''"></div>
</div>

<pre>{{ htmlContent }}</pre>
-->
